import GlassWrapper from '@components/glassWrapper/GlassWrapper'
import BasicLayout from '@components/layout/BasicLayout'
import FullScreenSection from '@components/layout/FullScreenSection'
import PrivacyPolicyText from '@components/privacyPolicyText/PrivacyPolicyText'
import getDynasties from '@operations/queries/getDynasties'
import getPage from '@operations/queries/getPage'
import getSiteSettings from '@operations/queries/getSiteSettings'
import React from 'react'

const PrivacyPolicy = ({ data: { siteSettings, dynastiesList } }) => {
  return (
    <BasicLayout
      dynastiesList={dynastiesList}
      footerLinks={siteSettings?.footerLinks}
      footerLogo={siteSettings?.footerLogo?.url}
      headerLinks={siteSettings?.headerLinks}
      headerLogo={siteSettings?.logo?.url}
      socialLinks={siteSettings?.socialLinks}
    >
      <FullScreenSection>
        <GlassWrapper>
          <PrivacyPolicyText />
        </GlassWrapper>
      </FullScreenSection>
    </BasicLayout>
  )
}

export default PrivacyPolicy

export const getStaticProps = async () => {
  let siteSettings
  let page
  let dynastiesList = []
  if (process.env.API_URL) {
    page = await getPage('privacy-policy')
    siteSettings = await getSiteSettings()
    dynastiesList = await getDynasties()
  }

  return {
    props: {
      data: {
        dynastiesList: dynastiesList || null,
        page: page?.[0] || null,
        siteSettings: siteSettings || null,
      },
    },
  }
}
